module.exports = __webpack_public_path__ + "static/img/09.6921652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/12/09.png
// module id = IraD
// module chunks = 2